// extracted by mini-css-extract-plugin
export default {"wrapperTurkishMefete":"TurkishMefete_wrapperTurkishMefete__oU1Zz","checkboxDescriptions":"TurkishMefete_checkboxDescriptions__PMw+B"};